/** Personal Cards product. The old id remains for persisted-tab cleanup. */
import { useUi } from "@/store/ui";
import { registerCommand } from "./registry";

export const CARDS_TAB = "cards:home";

export function openCards(): void {
  useUi.getState().setActiveApp("cards");
}

registerCommand({
  id: "cards.open",
  title: "Open Cards",
  defaultKeys: "$mod+Shift+k",
  section: "Cards",
  run: openCards,
});
